import type { Task } from "@app/core";

/**
 * Whether `task` is an EVENT whose end is already in the past relative to `now`.
 * Only events dim — never plain tasks. All-day events count as past once their
 * LAST covered day has elapsed (multi-day spans dim only after the whole span,
 * mirroring `build-days`' `ceil(duration/1440)` day count). `now` is an
 * argument (no `Date.now()` in render logic).
 */
export function isPastEvent(task: Task, now: Date): boolean {
  if (!task.is_event || !task.due_at) return false;
  const start = new Date(task.due_at);
  if (task.all_day) {
    const days = Math.max(1, Math.ceil(Math.max(0, task.duration_minutes) / 1440));
    const end = new Date(start);
    end.setDate(end.getDate() + (days - 1));
    end.setHours(23, 59, 59, 999);
    return end.getTime() < now.getTime();
  }
  const endMs = start.getTime() + Math.max(0, task.duration_minutes) * 60_000;
  return endMs < now.getTime();
}
